import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownWithoutOptionsProps } from "../models";
import { formatMonths } from "utilities";

const historyOptions = Array.from({ length: 60 }, (_, i) => i + 1)
  .map(i => ({ label: `${formatMonths(i)}`, value: i }));

const historyMap = historyOptions.reduce((acc, curr) => {
  acc[curr.value] = curr;
  return acc;
}, {} as any);

const ExternalCalendarHistoryDropdown = (props: DropdownWithoutOptionsProps<number, number>) => {
  const selectedHistory = historyMap[props.value];

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={historyOptions}
    getLabel={(h) => h.label}
    getValue={(h) => h.value}
    value={selectedHistory}
    onChange={v => { props.onChange(v.value); }}
    config={{
      isSearchable: true,
      shouldRenderSelectedValue: true,
      ...props.config
    }}
  />;
};

export default ExternalCalendarHistoryDropdown;
